const breadCrumb = "Lançamento de Notas - Lançamento de Aspectos Socioafetivos";

const routes = [
  {
    path: "/permitir-lancamento-de-aspectos-socioafetivos-por-aluno",
    name: "permitir-lancamento-de-aspectos-socioafetivos-por-aluno",
    meta: {
      allowedPermissions: ["buscar_aspectos_socioafetivos_aluno"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancamentoDeAspectosSocioafetivosPorAluno/PermitirLancamentoDeAspectosSocioafetivosPorAluno.vue"
      ),
  },
  {
    path: "/permitir-lancamento-de-aspectos-socioafetivos-por-aluno/:anoMatricula/:alunoId/:periodoId/editar",
    name: "permitir-lancamento-de-aspectos-socioafetivos-por-aluno-editar",
    meta: {
      allowedPermissions: [
        "buscar_aspectos_socioafetivos_aluno",
        "aluno_aspecto_create",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancamentoDeAspectosSocioafetivosPorAluno/PermitirLancamentoDeAspectosSocioafetivosPorAlunoEditar.vue"
      ),
  },
];

export default routes;
